import React, { useCallback } from 'react';
import { type Href, Link } from 'expo-router';

import { Navbar } from '@sg/garnish';

import { useTelemetry } from '@order/Telemetry';

import type { Asset, Entry } from 'contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarMoreContentLink = (props: Props) => {
  const { link, onPress, variant } = props;

  const { track } = useTelemetry();

  // ─── Handlers ────────────────────────────────────────────────────────

  const handlePress = useCallback(() => {
    track('nav_more_content_selected', {
      title: link.fields.title,
      url: link.fields.url,
    });
    onPress();
  }, [link.fields.title, link.fields.url, onPress, track]);

  // ─────────────────────────────────────────────────────────────────────

  if (variant === 'drawer') {
    return (
      <Link asChild href={link.fields.url as Href}>
        <Navbar.Floating.Drawer.NavLink onPress={handlePress}>
          {link.fields.title}
        </Navbar.Floating.Drawer.NavLink>
      </Link>
    );
  }

  return (
    <Link asChild href={link.fields.url as Href}>
      <Navbar.Floating.PageLink
        title={link.fields.title}
        description={link.fields.text}
        imageSrc={link.fields.image.fields.file.url}
        imageAlt={link.fields.image.fields.description}
        onPress={handlePress}
      />
    </Link>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  link: Entry<NavigationLink>;
  onPress: () => void;
  variant: 'drawer' | 'page';
};

type NavigationLink = {
  title: string;
  text?: string;
  url: string;
  image: Asset;
};
